import React from 'react';
import PropTypes from 'prop-types';

export class OutlookPreview extends React.PureComponent {
  render() {
    const previewSpecificClass =
      this.props.isMobilePreview ? 'mobile-web-outlook' : 'web-desktop-outlook';
    const previewContentClassName =
      `${previewSpecificClass} responsive-ad-preview-content`;

    return (
      <div className="new-responsive-ad-preview-container" >
        <a
          className={previewContentClassName}
          target="_blank"
          rel="noopener noreferrer"
          href={this.props.previewTexts.url}
        >
          <div className="ad-logo">
            <p>
              {this.props.i18n.getString('Entity_Ads')}
            </p>
          </div>
          <div className="business-name">
            {this.props.previewTexts.businessName}
          </div>
          {
            !this.props.isMobilePreview &&
            <div className="down-arrow" />
          }
          <div className="short-headline">
            {this.props.previewTexts.shortHeadline}
          </div>
          {
            !this.props.isMobilePreview &&
            <div className="description-separator">
              *
            </div>
          }
          <div className="description">
            {this.props.previewTexts.description}
          </div>
        </a>
        <div className="preview-type-string">
          {
            this.props.isMobilePreview ?
              this.props.i18n.getString('Audience_Campaign_Ad_Preview_MobileWebOutlook') :
              this.props.i18n.getString('Audience_Campaign_Ad_Preview_WebDesktopOutlook')
          }
        </div>
      </div>
    );
  }
}

OutlookPreview.propTypes = {
  previewTexts: PropTypes.shape({
    shortHeadline: PropTypes.string,
    description: PropTypes.string,
    businessName: PropTypes.string,
    url: PropTypes.string,
  }).isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
    parseDecimal: PropTypes.func.isRequired,
  }).isRequired,
  isMobilePreview: PropTypes.bool.isRequired,
};

